export default __webpack_public_path__ + "assets/d6925ce9804d897ed1758b444ca7aac9.png";